import { render, staticRenderFns } from "./PepItem.vue?vue&type=template&id=1ea80959&scoped=true&"
import script from "./PepItem.vue?vue&type=script&lang=js&"
export * from "./PepItem.vue?vue&type=script&lang=js&"
import style0 from "./PepItem.vue?vue&type=style&index=0&id=1ea80959&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea80959",
  null
  
)

export default component.exports